import { writable } from "svelte/store";
import { service } from "./services";
import type {  ApiResultOfListOfGame as ApiResultOfListOfAddGroupResponse, ApiResultOfListOfGroupDTO, Group, GroupDTO } from "./walletapi";
import { RegisterStartupCallback } from "./startup";


export const groups = writable<GroupDTO[]>([]);


//let firstStartup = true;
export async function GroupListStartup(firstStartup: boolean)
{
    RefreshGroups();

    if (!firstStartup) return;
    //firstStartup = false;

    service.walletapi.registerOperation("GroupChanged", "GroupChanged", GroupChanged);
    service.walletapi.registerOperation("GroupAdded", "GroupAdded", GroupAdded);
}

RegisterStartupCallback("GroupListStartup", GroupListStartup);

export async function RefreshGroups() {
    try {
        console.log('🔄 Iniciando RefreshGroups...');
        
        let response: ApiResultOfListOfGroupDTO = await service.walletapi.groupList({
            Token: sessionStorage.token,
        });

        console.log('📡 Respuesta completa del servidor:', response);
        console.log('✅ Success:', response.Success);
        console.log('📊 Data recibida:', response.Data);

        if (response.Success && response.Data) {
            // Procesar y convertir los datos para asegurar tipos correctos
            const processedGroups: GroupDTO[] = response.Data.map(group => ({
                ...group,
                Id: Number(group.Id),
                ParentId: group.ParentId !== null && group.ParentId !== undefined ? Number(group.ParentId) : undefined
            }));

            // Log detallado de cada grupo procesado
            console.log('🔍 Analizando cada grupo procesado:');
            processedGroups.forEach((group, index) => {
                console.log(`  Grupo ${index + 1}:`, {
                    Id: group.Id,
                    Name: group.Name,
                    ParentId: group.ParentId,
                    ParentIdType: typeof group.ParentId,
                    ParentIdValue: group.ParentId,
                    Users: group.Users
                });
            });

            groups.set(processedGroups);
            console.log('✅ Grupos procesados y actualizados en el store');
        } else {
            console.error('❌ Error al obtener la lista de grupos:', response.ErrorMessage);
        }
    } catch (error) {
        console.error('💥 Error en la llamada a la API:', error);
    }
}

export function GroupChanged(group: Group)
{   
    console.log("GroupChanged", group);

    groups.update(list => {
        let groupIndex = list.findIndex(p => p.Id == group.Id);
        if (groupIndex == -1)
        {
            // no such group
            return list;
        }
        
        list[groupIndex] = group;

        return list;
    });
};

export function GroupAdded(group: Group)
{   
    console.log("GroupAdded", group);

    groups.update(list => {
        list.unshift(group);
        return list;
    });
};
